import { stdObject } from "./types/stdObject";

export const fieldNotAllowed: stdObject = {
  PED: ["STOCK", "MOD"],
  ENT: ["MOD"],
  CFA: ["MOD"],
  SAL: ["MOD", "DES", "IMP"],
  TRA: ["MOD", "DES", "IMP", "PRE", "TOT"],
  TRA2: ["MOD"],
  COT: ["STOCK", "MOD"],
  ORD: ["MOD"],
  PRE: ["MOD"],
  FAC: ["MOD"],
  ALC: ["MOD"],
  SEV: ["MOD"],
};
